import React from "react";
import Products from "./ProductList";
import Categories from "./CategoryList";
import SearchBar from "./SearchBar";

const Marketplace = props => {
  return (
    <div className="marketplace-container">
      <SearchBar {...props} />
      <Products />
      <Categories />
    </div>
  );
};

export default Marketplace;



// WEBPACK FOOTER //
// ./components/marketplace/Marketplace.jsx